export const environment = {
  production: false,
  apiUrl: "https://app.overflysports.com",
  maderasParent: ["Maple", "Birch", "Ash"],
  // stripeMx: "pk_live_ruVh4NURzX7Bz1ENCgxtaVyq00i02bBjTa",
  stripeMx:
  "pk_live_51R1VxrGEXoJqnbieqHDDdC9LfzXOIHibdP5gCqBRyhBk06GeLZClgQEcLDLUu6vqShL2YrVnFiEpig16ZaYAMq4Y0011NvZt71",
  stripeUS: "pk_live_hqdf6FKGWeoe4JC35YOjVqYU003UaO89jz",
  paypalId:
    "AYn2lAhInrrOrYeaUMjT7_bhrDjQO_4wmXNebQ95qLHMVUzXV-ozMAJ2dkMz6izh-epSe2swpq_wOF2I",
  customBatPrices: {
    en: { precio: 189, copa: 15, peso: 15, tiempo: 35, nickName: 15 },
    es: { precio: 2840, copa: 400, peso: 400, tiempo: 300, nickName: 400 },
  },
  shipping: {
    USA: {
      fast: {
        multiple: 19,
        single: 16,
      },
      regular: {
        multiple: 12,
        single: 9,
      },
    },
    MEX: {
      fast: {
        multiple: 342,
        single: 288,
      },
      regular: {
        multiple: 216,
        single: 162,
      },
    },
  },
};
